<template>
  <div id="structural-foundation">
    Structural Foundation
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque molestias quidem sed, nisi cumque consectetur animi tempore nemo corporis, delectus corrupti cupiditate, fugit ipsa eum! Rerum cupiditate eius in dolorum!
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#structural-foundation{
    height: 300px;
    width: 85%;
    margin: auto;
    text-align: center;
    /* border: 1px solid black; */
}
</style>